__turbopack_context__.v({
  "activeContent": "eZZCuW_activeContent",
  "activeContentInner": "eZZCuW_activeContentInner",
  "desktopNavbarItem": "eZZCuW_desktopNavbarItem",
  "navbar": "eZZCuW_navbar",
  "overlay": "eZZCuW_overlay",
  "viewport": "eZZCuW_viewport",
  "visible": "eZZCuW_visible",
});
